'use client';
import { Radio } from '@material-tailwind/react';

type RadioButtonGroup = {
  helpText?: React.ReactNode;
  options: { value: string; label: string; isBold?: boolean }[];
  defaultCheckedOption?: string;
  onClick: (val: string) => void;
  name: string;
  label?: string;
  value?: string;
  stacked?: boolean;
};

export const RadioButtonGroup: React.FC<RadioButtonGroup> = ({
  defaultCheckedOption,
  helpText,
  options,
  onClick,
  name,
  label,
  stacked = false,
}) => {
  return (
    <div className="flex flex-col">
      {!!label && (
        <p className="font-medium text-gray-800 text-base">{label}</p>
      )}
      <div className={stacked ? 'flex flex-col gap-2' : 'flex gap-4'}>
        {options.map((option) => (
          <Radio
            key={option.value}
            className="transition-all duration-200 text-gray-800 before:hidden checked:border-primary-800 checked:bg-primary-800 checked:before:bg-primary-800 hover:!border-border/form-hover hover:shadow-md lg:size-6"
            defaultChecked={option.value === defaultCheckedOption}
            iconProps={{
              className: 'text-white [&>svg]:w-[10px] [&>svg]:h-[10px]',
            }}
            labelProps={{
              className: 'font-medium text-base text-gray-800',
            }}
            label={option.label}
            name={name}
            onClick={() => {
              onClick(option.value);
            }}
            ripple={false}
            value={option.value}
          />
        ))}
      </div>

      {!!helpText && helpText}
    </div>
  );
};
